import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Divider, Header, Modal, Segment } from 'semantic-ui-react';
import { FileUploadInterface } from '../../models/Profile';
import { useStore } from '../../stores/store';

function HistoryModalComponent() {
  const { activityStore, modalStore } = useStore();
  const { fileDataVoice } = activityStore;
  const [fileData, setFileData] = useState<FileUploadInterface[]>([]);

  useEffect(() => {
    setFileData(fileDataVoice);
  }, [fileDataVoice]);

  return (
    <div>
      <Header>Voice Clip</Header>
      <div>
        {fileData?.map((x) => {
          return (
            <Segment>
              <audio style={{ width: '100%' }} autoPlay controls src={x.url} />
            </Segment>
          );
        })}
        <Modal.Actions>
          <Divider />
          <Button
            style={{ marginBottom: '20px' }}
            color="black"
            floated="right"
            onClick={() => modalStore.closeSmallModal()}
          >
            Close
          </Button>
        </Modal.Actions>
      </div>
    </div>
  );
}

export default observer(HistoryModalComponent);
